import { Extension } from '@tiptap/core'
import { CitationMinuteNodes } from '../../../../../../backend/src/citations/minutes-citations-api.dto'
import { CitationPluginOptions, OpenDocumentEvent, ResourceInfo, createCitationPlugin } from './citation-plugin'

export type CitationExtensionOptions = {
  getCitations: () => CitationMinuteNodes | null
  getResources: () => ResourceInfo[]
  formatPageLabel: (page: number) => string
  formatMorePassages: (count: number) => string
  onOpenDocument: ((event: OpenDocumentEvent) => void) | null
  onOpenMeeting: ((event: { startSentenceId: string; endSentenceId: string }) => void) | null
}

export const CitationExtension = Extension.create<CitationExtensionOptions>({
  name: 'citation',

  addOptions() {
    return {
      getCitations: () => ({}),
      getResources: () => [],
      formatPageLabel: (page: number) => `Page ${page}`,
      formatMorePassages: (count: number) => `+${count} more`,
      onOpenDocument: null,
      onOpenMeeting: null,
    }
  },

  addProseMirrorPlugins() {
    const pluginOptions: CitationPluginOptions = {
      getCitations: this.options.getCitations,
      getResources: this.options.getResources,
      formatPageLabel: this.options.formatPageLabel,
      formatMorePassages: this.options.formatMorePassages,
      onOpenDocument: this.options.onOpenDocument,
      onOpenMeeting: this.options.onOpenMeeting,
    }

    return [createCitationPlugin(pluginOptions)]
  },
})
